<div class="mark-loader mark-loader--backdrop">
  <mat-progress-spinner mode="indeterminate" diameter="64"> </mat-progress-spinner>
</div>
